import { DeleteResponse } from '@customTypes/api/Notification';
import { Endpoints, ServiceAPI } from '@service/index';
import { useMutation } from 'react-query';

const useDeleteNotification = () => {
  return useMutation((notificationIds: string[]) => {
    return ServiceAPI.delete<{ notification_ids: string[] }, DeleteResponse>(
      Endpoints.Notification(),
      {
        notification_ids: notificationIds,
      },
    );
  });
};

export default useDeleteNotification;
